export enum PaymentPlanId {
  Credit = 1,
  PrePaid = 2,
  Denied = 3,
}
